export { ScrollView as default } from 'react-native';
